/**
 * @desc 财务画像-基础信息-人员信息
 */
import React from 'react';
import style from '../personnelMessage/personnelMessage.scss';
import NoData from '../../../common/noData/NoData';
import BBDPie from '../../../common/echarts/BBDPie';
import {Spin} from 'antd';
import {isNotEmpty } from '../../../../utils/util';
import {commonPieOption} from '../../common/commons';

export default function PersonMSPie({pieData, loading, years}) {
    let legend = {
            type: 'scroll',
            x: years ? '20%' : 'left',
            left: years ? '42%' : '56%',
            height: 190
        },
        center = [years ? '22%' : '35%', '51%'],
        config = commonPieOption(legend, center, '', claerData(pieData));

    return (
        <div>
            {
                loading ? <Spin /> :
                    isNotEmpty(config) ?
                        <div className={style.educationInfo}>
                            <BBDPie option={config} />
                        </div> : <NoData />
            }
        </div>
    );
}
    
// 遍历饼图数据
export function claerData(data) {
    if (!isNotEmpty(data)) {
        return {};
    }
    let yearData = [];
    for (var i in data) {
        yearData.push({ name: i, value: data[i] });
    }
    return yearData;
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/common/PersonMSPie.jsx